import { useEffect, useState } from 'react'

import useTranslations from '../../../../hooks/useTranslations'
import ANTDForm, { useFormFn } from '../../../../shared/antd/ANTDForm'
import { userWiseRole } from '../../../../utils/constant'
import { modifyFileListKeys } from '../../../../utils/customFunctions'
import { dayJs, DISPLAY_DATE_FORMAT } from '../../../../utils/dayjs'
import {
  entries,
  include,
  isArray,
  isEqual,
  keys,
  length,
  notEqual,
} from '../../../../utils/javascript'
import UserTable from '../../../userManagement/presentation/UserTable'
import inspectionFieldAttr from '../../container/inspectionFieldAttr.container'
import InspectionDetailsView from '../addJobs/inspection/InspectionDetailsView'
import InspectionFormField from '../addJobs/inspection/InspectionFormField'
import DetailListView from '../common/DetailListView'

const InspectionJobView = ({ data }) => {
  const { t } = useTranslations()
  const form = useFormFn()
  const [inspectionData, setInspectionData] = useState([])

  const { inspectionOfficer } = userWiseRole
  const infoData = {
    user_BasicInformation: [
      { label: 'user_ID', value: data?.id },
      { label: 'job_DateOfInspectionAndTime', value: data?.inspectionDate },
      {
        label: 'user_CreationDate',
        value: data?.creationDate
          ? dayJs(data?.creationDate).format(DISPLAY_DATE_FORMAT)
          : '-',
      },
      { label: 'job_Status', value: t(data?.status) },
    ],
  }

  const {
    administrationAttrFn,
    hostelInfraRoomsAttrFn,
    childrenAttrFn,
    educationAttrFn,
    suppliesAttrFn,
    generalHealthAttrFn,
    phcConnectivityAttrFn,
    feedbackAttrFn,
    findingsAttrFn,
  } = inspectionFieldAttr()

  useEffect(() => {
    setViewData()
  }, [])

  const setViewData = () => {
    const mapKeyValue = (attributes, values) => {
      const details = {}
      entries(attributes)?.forEach(([key, item]) => {
        if (item.inputType === 'select') {
          const optKeyMap = item.options?.reduce((acc, item) => {
            acc[item?.value] = item?.label
            return acc
          }, {})
          if (item.mode === 'multiple') {
            details[key] = isArray(values?.[key])
              ? values?.[key]
                  ?.map(stgKey => t(optKeyMap?.[stgKey]) || '-')
                  ?.join(', ')
              : '-'
          } else {
            details[key] = optKeyMap?.[values?.[key]] || '-'
          }
          details[`${key}Selected`] = values?.[key]
        } else if (include(['formUpload', 'canvas'], item.inputType)) {
          const detailsKey = key.endsWith('Ids')
            ? `${key.slice(0, -3)}Details`
            : `${key}Details`
          details[key] = length(values?.[detailsKey])
            ? {
                fileList: modifyFileListKeys(values?.[detailsKey]),
              }
            : null
        } else {
          details[key] = values?.[key] ?? '-'
        }
      })
      return details
    }
    const inspectionValues = {
      anganwadiCenter: data?.anganwadiInfo,
      administrationRequestDto: mapKeyValue(
        administrationAttrFn({
          awtParticipateActivities:
            data?.doesAwtAwhParticipateInOtherActivities,
          awtPresentAtTimeOfVisit: data?.whetherAwtPresentAtTimeOfVisit,
          awhPresentAtTimeOfVisit: data?.whetherAwhPresentAtTimeOfVisit,
          // awcOpenedLocation: data?.whetherAwcOpened,
          areStockRegistersUpdated: data?.areStockRegistersUpdated,
          studentAttendanceRegistersUpdated:
            data?.areStudentAttendanceRegistersMaintainedUpToDate,
          // anyVacancyAvailableForAwtAwh: data?.anyVacancyAvailableForAwtAwh,
        }),
        data,
      ),
      infrastructureRequestDto: mapKeyValue(
        hostelInfraRoomsAttrFn({
          isElectricity: data?.isElectricityAvailable,
          hasBolaPaintings: data?.whetherAwcIsHavingBolaArtisticPaintings,
          freshPaintingNeeded: data?.whetherFreshPaintingNeeded,
          nutriGardenAvailable: data?.whetherNutriGardenAvailableMaintained,
          doesAwcHaveBasicAmenities: data?.doesAwcHaveBasicAmenities,
          doesAwcHaveDesignatedLearningCorners:
            data?.doesAnganwadiCentreHaveDesignatedLearningCorners,
          doesAwcHaveAdequateFurniture:
            data?.doesAnganwadiCentreHaveAdequateFurnitureAvailable,
          doesAwcHavePlayEquipments:
            data?.doesAnganwadiCentreHavePlayEquipments,
          areFansLightsWorkingEfficiently:
            data?.areFansLightsWorkingEfficiently,
          toiletsRepairsFeedback: data?.toiletsRepairsFeedback,
        }),
        data,
      ),
      childrenRequestDto: (() => {
        const childrenData = mapKeyValue(
          childrenAttrFn({
            childrenPresentInUniform: data?.childrenPresentInUniform,
            breakfastGiven: data?.isBreakfastGiven,
            lunchGiven: data?.isLunchGiven,
            // samChildrenPresentAtTimeOfVisit:
            //   data?.whetherSamChildrenPresentAtTimeOfVisit,
            // mamChildrenPresentAtTimeOfVisit:
            //   data?.whetherMamChildrenPresentAtTimeOfVisit,
            disableChildEnrolled: data?.whetherAnyDisableChildEnrolledInAwc,
          }),
          data,
        )
        // Calculate girls field based on formula: girls = total - boys
        const totalSamChildren =
          childrenData?.totalNoOfSamChildrenInAwc ||
          data?.totalNoOfSamChildrenInAwc ||
          0
        const boysSamValue =
          childrenData?.noOfSamChildrenBoysInAwc ||
          data?.noOfSamChildrenBoysInAwc
        if (
          boysSamValue != null &&
          boysSamValue !== '' &&
          boysSamValue > 0 &&
          totalSamChildren > 0 &&
          boysSamValue <= totalSamChildren
        ) {
          childrenData.noOfSamChildrenGirlsInAwc =
            totalSamChildren - boysSamValue
        }
        const totalMamChildren =
          childrenData?.totalNoOfMamChildrenInAwc ||
          data?.totalNoOfMamChildrenInAwc ||
          0
        const boysMamValue =
          childrenData?.noOfMamChildrenBoysInAwc ||
          data?.noOfMamChildrenBoysInAwc
        if (
          boysMamValue != null &&
          boysMamValue !== '' &&
          boysMamValue > 0 &&
          totalMamChildren > 0 &&
          boysMamValue <= totalMamChildren
        ) {
          childrenData.noOfMamChildrenGirlsInAwc =
            totalMamChildren - boysMamValue
        }
        return childrenData
      })(),
      educationRequestDto: mapKeyValue(
        educationAttrFn({
          dailyEcceActivitiesConducted:
            data?.wereDailyEcceActivitiesConductedAsPerSchedule,
          ecceDayConducted: data?.wasEcceDayConductedDuringCurrentMonth,
        }),
        data,
      ),
      suppliesRequestDto: mapKeyValue(
        suppliesAttrFn({
          // malnourishedChildren: data?.areThereAnyMalnourishedChildrenPresent,
          supplementsRegular: data?.areSupplementsExtraFoodsProvidedRegularly,
          // imageCapturedThr: data?.imageCapturedThr,
          foodMenuChartDisplayed: data?.whetherFoodMenuChartDisplayedInAwc,
          morningSnacksGiven: data?.whetherMorningSnacksGivenToBeneficiaries,
          imageCapturedForMorningSnacks: data?.imageCapturedForMorningSnacks,
          hotMealCookedAsPerMenu: data?.whetherHotMealCookedAsPerMenu,
          // imageCapturedHotCookedMeal: data?.imageCapturedHotCookedMeal,
        }),
        data,
      ),
      generalHealthRequestDto: mapKeyValue(
        generalHealthAttrFn({
          // weightChange: data?.isThereAnySuddenLossOrGainOfWeightOfChild,
          // malNourished: data?.isChildMalnourished,
          // obeseChild: data?.isChildObese,
        }),
        data,
      ),
      phcConnectivityRequestDto: mapKeyValue(phcConnectivityAttrFn(), data),
      feedbackRequestDto: mapKeyValue(
        feedbackAttrFn({
          healthCheckupsConducted:
            data?.wereHealthCheckupsConductedForAllChildrenAtAwcDuringCurrentMonth,
          almscCommitteeMeetingConducted:
            data?.wasAlmscCommitteeMeetingConductedDuringCurrentMonth,
          healthCheckupsConductedSecond:
            data?.wereHealthCheckupsConductedForAllChildrenAtAwcDuringCurrentMonthSecond,
          homeVisitsConducted:
            data?.wereHomeVisitsConductedDuringCurrentMonthAsPerTarget,
          vhsndMeetingConducted:
            data?.wasVhsndMeetingConductedDuringCurrentMonth,
          communityBasedEventsConducted:
            data?.wereCommunityBasedEventsConductedDuringCurrentMonth,
          // anySuggestions: data?.anySuggestions,
        }),
        data,
      ),
    }
    setInspectionData([inspectionValues])

    //for finding section
    const dateToDayJs = date => (date ? dayJs(date, 'DD/MM/YYYY') : null)
    const formValueFromResponse = (details, formAttr) => {
      const data = {}
      entries(details)?.forEach(([key, value]) => {
        if (!formAttr?.[key]) return
        const fieldType = formAttr?.[key]?.inputType

        if (isEqual(fieldType, 'dateTimePicker')) {
          data[key] = dateToDayJs(value)
        } else if (isEqual(fieldType, 'timePicker')) {
          data[key] =
            value &&
            notEqual(dayJs(value, 'HH:mm')?.format('HH:mm'), 'Invalid Date')
              ? dayJs(value, 'HH:mm')?.format('HH:mm')
              : null
        } else if (include(['formUpload', 'canvas'], fieldType)) {
          const detailsKey = key.endsWith('Ids')
            ? `${key.slice(0, -3)}Details`
            : `${key}Details`
          data[key] = length(details?.[detailsKey])
            ? {
                fileList: modifyFileListKeys(details?.[detailsKey]),
              }
            : null
        } else {
          data[key] = value
        }
      })
      return data
    }
    form.setFieldsValue({
      findingsRequestDto: {
        ...formValueFromResponse(data, findingsAttrFn()),
      },
    })
  }

  return (
    <>
      <DetailListView infoData={infoData} title="job_InspectionJob" />

      <h2 className="content-title">{t('user_InspectionOfficer')}</h2>
      <UserTable
        className="mb-15"
        userData={{
          loader: false,
          list: length(keys(data?.userInfo)) ? [data?.userInfo] : [],
        }}
        payload={{ roleId: inspectionOfficer }}
        permission={false}
        pagination={false}
      />

      <InspectionDetailsView inspectionData={inspectionData} />

      <ANTDForm
        name="inspection"
        initialValues={{}}
        form={form}
        layout="vertical"
      >
        <InspectionFormField
          {...{
            attrList: findingsAttrFn(),
            name: 'findingsRequestDto',
            disabledAll: true,
          }}
        />
      </ANTDForm>
    </>
  )
}

export default InspectionJobView
